module.exports = __webpack_public_path__ + "static/media/eversana_logo_large_bl.2716b6c8.png";